import { JSONSchema6 } from "json-schema";
 
const getReportByIdSchema: JSONSchema6 = {
    title: "Get Report By Id",
    description: "Get Report By Id details contains report details for the given report id. Where report contains the details such as report id, report type, processing status and report document id. Report document id will be returned only when the processing status is in complete status.",
    properties: {
        "pathParam": {
            title: "reportId",
            type: "string",
        }
    },
    required: ["pathParam"]
}
 
export default getReportByIdSchema;